(ns com.theplantscape.plant-web.components.tailwind.sidebar
  (:require [com.theplantscape.web-ui.ensemble :refer [icon-close]])
)


(defn sidebar [config ]
  [:div.md:relative.mx-auto.lg:px-6
   (:header config)
   (:links config)])
